import { InjectionToken } from '@angular/core';

export interface TabsConfig {
  phoneSelect?: boolean;
}

export const TABS_CONFIG = new InjectionToken<TabsConfig>('TABS_CONFIG');
